"use client";
import { useState } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

// utils/languages.js
// languages.js
export const languages = [
  { code: "ab", name: "Abkhaz", },
  { code: "ace", name: "Acehnese", },
  { code: "ach", name: "Acholi", },
  { code: "af", name: "Afrikaans", flag: "🇿🇦" },
  { code: "sq", name: "Albanian", flag: "🇦🇱" },
  { code: "alz", name: "Alur", },
  { code: "am", name: "Amharic", flag: "🇪🇹" },
  { code: "ar", name: "Arabic", flag: "🇸🇦" },
  { code: "hy", name: "Armenian", flag: "🇦🇲" },
  { code: "as", name: "Assamese", },
  { code: "awa", name: "Awadhi", },
  { code: "ay", name: "Aymara", },
  { code: "az", name: "Azerbaijani", flag: "🇦🇿" },
  { code: "ban", name: "Balinese", },
  { code: "bm", name: "Bambara", },
  { code: "ba", name: "Bashkir", },
  { code: "eu", name: "Basque", flag: "🇪🇺" },
  { code: "btx", name: "Batak Karo", },
  { code: "bts", name: "Batak Simalungun", },
  { code: "bbc", name: "Batak Toba", },
  { code: "be", name: "Belarusian", flag: "🇧🇾" },
  { code: "bem", name: "Bemba", },
  { code: "bn", name: "Bengali", flag: "🇧🇩" },
  { code: "bew", name: "Betawi", },
  { code: "bho", name: "Bhojpuri", },
  { code: "bik", name: "Bikol", },
  { code: "bs", name: "Bosnian", flag: "🇧🇦" },
  { code: "br", name: "Breton", },
  { code: "bg", name: "Bulgarian", flag: "🇧🇬" },
  { code: "bua", name: "Buryat", },
  { code: "yue", name: "Cantonese", flag: "🇭🇰" },
  { code: "ca", name: "Catalan", flag: "🇦🇩" },
  { code: "ceb", name: "Cebuano", },
  { code: "ny", name: "Chichewa (Nyanja)", },
  { code: "zh-CN", name: "Chinese (Simplified)", flag: "🇨🇳" },
  { code: "zh", name: "Chinese (Simplified) (alt)", flag: "🇨🇳" },
  { code: "zh-TW", name: "Chinese (Traditional)", flag: "🇹🇼" },
  { code: "cv", name: "Chuvash", },
  { code: "co", name: "Corsican", },
  { code: "crh", name: "Crimean Tatar", },
  { code: "hr", name: "Croatian", flag: "🇭🇷" },
  { code: "cs", name: "Czech", flag: "🇨🇿" },
  { code: "da", name: "Danish", flag: "🇩🇰" },
  { code: "din", name: "Dinka", },
  { code: "dv", name: "Divehi", },
  { code: "doi", name: "Dogri", },
  { code: "dov", name: "Dombe", },
  { code: "nl", name: "Dutch", flag: "🇳🇱" },
  { code: "dz", name: "Dzongkha", flag: "🇧🇹" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "eo", name: "Esperanto", },
  { code: "et", name: "Estonian", flag: "🇪🇪" },
  { code: "ee", name: "Ewe", },
  { code: "fj", name: "Fijian", flag: "🇫🇯" },
  { code: "fil", name: "Filipino (Tagalog)", flag: "🇵🇭" },
  { code: "tl", name: "Tagalog (alt)", flag: "🇵🇭" },
  { code: "fi", name: "Finnish", flag: "🇫🇮" },
  { code: "fr", name: "French", flag: "🇫🇷" },
  { code: "fr-FR", name: "French (France)", flag: "🇫🇷" },
  { code: "fr-CA", name: "French (Canada)", flag: "🇨🇦" },
  { code: "fy", name: "Frisian", },
  { code: "ff", name: "Fulfulde", },
  { code: "gaa", name: "Ga", },
  { code: "gl", name: "Galician", flag: "🇪🇸" },
  { code: "lg", name: "Ganda (Luganda)", },
  { code: "ka", name: "Georgian", flag: "🇬🇪" },
  { code: "de", name: "German", flag: "🇩🇪" },
  { code: "el", name: "Greek", flag: "🇬🇷" },
  { code: "gn", name: "Guarani", },
  { code: "gu", name: "Gujarati", },
  { code: "ht", name: "Haitian Creole", flag: "🇭🇹" },
  { code: "cnh", name: "Hakha Chin", },
  { code: "ha", name: "Hausa", },
  { code: "haw", name: "Hawaiian", flag: "🇺🇸" },
  { code: "iw", name: "Hebrew (old code)", flag: "🇮🇱" },
  { code: "he", name: "Hebrew", flag: "🇮🇱" },
  { code: "hil", name: "Hiligaynon", },
  { code: "hi", name: "Hindi", flag: "🇮🇳" },
  { code: "hmn", name: "Hmong", },
  { code: "hu", name: "Hungarian", flag: "🇭🇺" },
  { code: "hrx", name: "Hunsrik", },
  { code: "is", name: "Icelandic", flag: "🇮🇸" },
  { code: "ig", name: "Igbo", flag: "🇳🇬" },
  { code: "ilo", name: "Iloko", },
  { code: "id", name: "Indonesian", flag: "🇮🇩" },
  { code: "ga", name: "Irish", flag: "🇮🇪" },
  { code: "it", name: "Italian", flag: "🇮🇹" },
  { code: "ja", name: "Japanese", flag: "🇯🇵" },
  { code: "jw", name: "Javanese", flag: "🇮🇩" },
  { code: "jv", name: "Javanese (alt)", flag: "🇮🇩" },
  { code: "kn", name: "Kannada", },
  { code: "pam", name: "Kapampangan", },
  { code: "kk", name: "Kazakh", flag: "🇰🇿" },
  { code: "km", name: "Khmer", flag: "🇰🇭" },
  { code: "cgg", name: "Kiga", },
  { code: "rw", name: "Kinyarwanda", flag: "🇷🇼" },
  { code: "ktu", name: "Kituba", },
  { code: "gom", name: "Konkani", },
  { code: "ko", name: "Korean", flag: "🇰🇷" },
  { code: "kri", name: "Krio", },
  { code: "ku", name: "Kurdish (Kurmanji)", },
  { code: "ckb", name: "Kurdish (Sorani)", },
  { code: "ky", name: "Kyrgyz", flag: "🇰🇬" },
  { code: "lo", name: "Lao", flag: "🇱🇦" },
  { code: "ltg", name: "Latgalian", },
  { code: "la", name: "Latin", },
  { code: "lv", name: "Latvian", flag: "🇱🇻" },
  { code: "lij", name: "Ligurian", },
  { code: "li", name: "Limburgan", },
  { code: "ln", name: "Lingala", },
  { code: "lt", name: "Lithuanian", flag: "🇱🇹" },
  { code: "lmo", name: "Lombard", },
  { code: "luo", name: "Luo", },
  { code: "lb", name: "Luxembourgish", flag: "🇱🇺" },
  { code: "mk", name: "Macedonian", flag: "🇲🇰" },
  { code: "mai", name: "Maithili", },
  { code: "mak", name: "Makassar", },
  { code: "mg", name: "Malagasy", flag: "🇲🇬" },
  { code: "ms", name: "Malay", flag: "🇲🇾" },
  { code: "ms-Arab", name: "Malay (Jawi)", },
  { code: "ml", name: "Malayalam", flag: "🇮🇳" },
  { code: "mt", name: "Maltese", flag: "🇲🇹" },
  { code: "mi", name: "Maori", flag: "🇳🇿" },
  { code: "mr", name: "Marathi", flag: "🇮🇳" },
  { code: "chm", name: "Meadow Mari", },
  { code: "mni-Mtei", name: "Meiteilon (Manipuri)", },
  { code: "min", name: "Minang", },
  { code: "lus", name: "Mizo", },
  { code: "mn", name: "Mongolian", flag: "🇲🇳" },
  { code: "my", name: "Myanmar (Burmese)", flag: "🇲🇲" },
  { code: "nr", name: "Ndebele (South)", },
  { code: "new", name: "Nepalbhasa (Newari)", },
  { code: "ne", name: "Nepali", flag: "🇳🇵" },
  { code: "nso", name: "Northern Sotho (Sepedi)", },
  { code: "no", name: "Norwegian", flag: "🇳🇴" },
  { code: "nus", name: "Nuer", },
  { code: "oc", name: "Occitan", },
  { code: "or", name: "Odia (Oriya)", flag: "🇮🇳" },
  { code: "om", name: "Oromo", },
  { code: "pag", name: "Pangasinan", },
  { code: "pap", name: "Papiamento", },
  { code: "ps", name: "Pashto", flag: "🇦🇫" },
  { code: "fa", name: "Persian", flag: "🇮🇷" },
  { code: "pl", name: "Polish", flag: "🇵🇱" },
  { code: "pt", name: "Portuguese", flag: "🇵🇹" },
  { code: "pt-PT", name: "Portuguese (Portugal)", flag: "🇵🇹" },
  { code: "pt-BR", name: "Portuguese (Brazil)", flag: "🇧🇷" },
  { code: "pa", name: "Punjabi", flag: "🇮🇳" },
  { code: "pa-Arab", name: "Punjabi (Shahmukhi)", },
  { code: "qu", name: "Quechua", },
  { code: "rom", name: "Romani", },
  { code: "ro", name: "Romanian", flag: "🇷🇴" },
  { code: "rn", name: "Rundi", },
  { code: "ru", name: "Russian", flag: "🇷🇺" },
  { code: "sm", name: "Samoan", flag: "🇼🇸" },
  { code: "sg", name: "Sango", },
  { code: "sa", name: "Sanskrit", },
  { code: "gd", name: "Scots Gaelic", flag: "🏴" },
  { code: "sr", name: "Serbian", flag: "🇷🇸" },
  { code: "st", name: "Sesotho", flag: "🇱🇸" },
  { code: "crs", name: "Seychellois Creole", },
  { code: "shn", name: "Shan", },
  { code: "sn", name: "Shona", },
  { code: "scn", name: "Sicilian", },
  { code: "szl", name: "Silesian", },
  { code: "sd", name: "Sindhi", },
  { code: "si", name: "Sinhala (Sinhalese)", flag: "🇱🇰" },
  { code: "sk", name: "Slovak", flag: "🇸🇰" },
  { code: "sl", name: "Slovenian", flag: "🇸🇮" },
  { code: "so", name: "Somali", flag: "🇸🇴" },
  { code: "es", name: "Spanish", flag: "🇪🇸" },
  { code: "su", name: "Sundanese", flag: "🇮🇩" },
  { code: "sw", name: "Swahili", flag: "🇰🇪" },
  { code: "ss", name: "Swati", },
  { code: "sv", name: "Swedish", flag: "🇸🇪" },
  { code: "tg", name: "Tajik", flag: "🇹🇯" },
  { code: "ta", name: "Tamil", flag: "🇮🇳" },
  { code: "tt", name: "Tatar", },
  { code: "te", name: "Telugu", flag: "🇮🇳" },
  { code: "tet", name: "Tetum", },
  { code: "th", name: "Thai", flag: "🇹🇭" },
  { code: "ti", name: "Tigrinya", },
  { code: "ts", name: "Tsonga", },
  { code: "tn", name: "Tswana", },
  { code: "tr", name: "Turkish", flag: "🇹🇷" },
  { code: "tk", name: "Turkmen", flag: "🇹🇲" },
  { code: "ak", name: "Twi (Akan)", },
  { code: "uk", name: "Ukrainian", flag: "🇺🇦" },
  { code: "ur", name: "Urdu", flag: "🇵🇰" },
  { code: "ug", name: "Uyghur", },
  { code: "uz", name: "Uzbek", flag: "🇺🇿" },
  { code: "vi", name: "Vietnamese", flag: "🇻🇳" },
  { code: "cy", name: "Welsh", flag: "🏴" },
  { code: "xh", name: "Xhosa", },
  { code: "yi", name: "Yiddish", },
  { code: "yo", name: "Yoruba", flag: "🇳🇬" },
  { code: "yua", name: "Yucatec Maya", },
  { code: "zu", name: "Zulu", flag: "🇿🇦" },
];

export default function TranslateDropdown() {
  const [selectedLang, setSelectedLang] = useState(null);

  const handleTranslate = (lang) => {
    setSelectedLang(lang);


    /*  const currentUrl = window.location.href;
     const url = new URL(currentUrl);
     const domain = url.hostname.replace(/\./g, "-");
     const translateUrl = `https://${domain}.translate.goog${url.pathname}${url.search}&_x_tr_sl=auto&_x_tr_tl=${lang.code}&_x_tr_hl=en`; */

    const currentUrl = window.location.href;
    // const domain = new URL(currentUrl).hostname.replace(/\./g, "-");
    const domain = "www-smartguy-com";

    const translateUrl = `https://${domain}.translate.goog${new URL(currentUrl).pathname}?_x_tr_sl=auto&_x_tr_tl=${lang}`;


    // window.location.href = translateUrl;
    window.open(translateUrl, "_blank");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="gap-2">
          <Globe className="h-4 w-4" />
          <span>{selectedLang ? selectedLang.name : "Translate"}</span>
          <ChevronDown className="h-4 w-4 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Select Language</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <div className="max-h-80 overflow-y-auto">
          {languages.map((lang) => (
            <DropdownMenuItem
              key={lang.code}
              onClick={() => handleTranslate(lang.code)}
              className="gap-x-2 gap-y-0 cursor-pointer flex items-center"
            >
              <div className="text-lg">{lang?.flag ?? <Globe className="size-4" />}</div>
              <div className="text-sm">{lang.name}</div>
              {selectedLang?.code === lang.code && (
                <Check className="h-4 w-4 text-primary" />
              )}
            </DropdownMenuItem>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}